if (!customElements.get('nopa-activity-showcase')) {
  class NopaActivityShowcase extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.items = [...this.querySelectorAll('[data-item]')];
      this.cta = this.querySelector('[data-cta]');
      if (!this.slides.length) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.activate(this.slides.indexOf(entry.target));
        });
      }, { threshold: 0.5 });
      this.slides.forEach((s) => io.observe(s));

      const vio = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const v = entry.target.querySelector('video');
          if (!v) return;
          entry.isIntersecting ? v.play().catch(() => {}) : v.pause();
        });
      }, { threshold: 0.25 });
      this.slides.forEach((s) => vio.observe(s));
    }
    activate(i) {
      if (i < 0) return;
      this.items.forEach((el, j) => el.classList.toggle('is-active', i === j));
      const active = this.items[i];
      if (this.cta && active && active.dataset.url) this.cta.href = active.dataset.url;
    }
  }
  customElements.define('nopa-activity-showcase', NopaActivityShowcase);
}
